import React, { FunctionComponent, memo, useMemo } from 'react';
import { Color, DoubleSide, Intersection, Object3D, Object3DEventMap, Raycaster, Shape as ThreeShape } from 'three';
interface IParentProps {
    name: string;
	opacity: number;
    shape: ThreeShape;
	color: string;
    renderOrder: number;
    depthWrite: boolean;
    raycast?: (_: Raycaster, intersects: Intersection<Object3D<Object3DEventMap>>[]) => void
}

const Shape: FunctionComponent<IParentProps> = ({ 
    shape: shp, 
    color: lColor, 
    opacity, 
    renderOrder,
    raycast
}) => {
    const color = useMemo(() => new Color(lColor), [lColor]);
    const geometry = useMemo(() => <shapeGeometry attach="geometry" args={[shp]} />, [shp])

	return (
        <group raycast={raycast} key={`shape_mesh_group`} name={`shape_mesh_group`}>
            <mesh raycast={raycast} renderOrder={1}>
				{geometry}
				<meshBasicMaterial 
                    colorWrite={false}
                    depthWrite={true}
                    polygonOffset={true} 
                    polygonOffsetUnits={10}
                    polygonOffsetFactor={10}
                    side={DoubleSide}
                />
			</mesh>
            <mesh raycast={raycast} renderOrder={renderOrder}>
                {geometry}
                <meshBasicMaterial
                    color={color}
                    opacity={opacity}
                    depthWrite={false}
                    transparent={true} 
                    side={DoubleSide}
                />  
            </mesh>
        </group> 
	);
};

export default memo(Shape);
